exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{text-align:center;color:#2c3e50;margin-left:10px;margin-top:10px}", ""]);

// exports
